import Vue from "vue";
import { Store, Module, ActionContext } from "vuex";
import Vuex from "vuex";
import Ajax from "../../lib/ajax";
Vue.use(Vuex);
interface MasterDataState {
  conditionTypes: Array<any>;
  documentTypes: Array<any>;
  brands: Array<any>;
}
class MasterDataModule implements Module<MasterDataState, any> {
  namespaced = true;
  state = {
    conditionTypes: [],
    documentTypes: [],
    brands: [],
  };
  actions = {
    async getConditionTypes(context: ActionContext<MasterDataState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetAllConditionTypes"
      );
      context.state.conditionTypes = reponse.data.result.items;
    },
    async getDocumentTypes(
      context: ActionContext<MasterDataState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetDocumentTypeByRefTypeCode",
        { params: payload.param }
      );
      context.state.documentTypes = reponse.data.result.items;
    },
    async getFeatureConditionTypes(
      context: ActionContext<MasterDataState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        `/api/services/app/MasterDataService/ConditionType/${
          payload.data.featureCode
        }`
      );
      context.state.conditionTypes = result.items;
    },
    async getAssetTypeServicesForSelect(
      context: ActionContext<MasterDataState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetAssetTypeServicesForSelect",
        { params: payload.data }
      );
      return reponse.data.result.items;
    },
    async getConditionTypeServicesForSelect(
      context: ActionContext<MasterDataState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetConditionTypeServicesForSelect",
        { params: payload.data }
      );
      return reponse.data.result.items;
    },
    async getFeatureConditionTypesForSelect(
      context: ActionContext<MasterDataState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/MasterDataService/GetFeatureConditionTypesForSelect",
        { params: payload.data }
      );
      return result.items;
    },
    async getBrands(context: ActionContext<MasterDataState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetBrandsForSelect"
      );
      context.state.brands = reponse.data.result.items;
      return reponse.data.result.items;
    },
    async getNotificationTypes(
      context: ActionContext<MasterDataState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetNotificationTypesForSelect",
        { params: payload.data }
      );
      return reponse.data.result.items;
    },
  };
  mutations = {};
}
const masterDataModule = new MasterDataModule();
export default masterDataModule;
